const LOAD_DEFAULT_PRODIS = (state) => {
  state.pd.res = -1
}

/* this is begining data entry with state_code is ZERO
  Append the prodis_empty to the prodis
  it is depend on the res from the backend server
  usually res is ONE, if res is TWO for editing existing data
*/

const LOAD_DATA_PRODIS = (state, payload) => {
  state.pd = payload
  // console.log('pd3' + state.pd)
}

/*
const LOAD_REPORT_PUBASCF_NOENTRY = (state, payload) => {
  state.notEntry = payload
  // load report not entry from database
}
*/

export {
  LOAD_DEFAULT_PRODIS,
  LOAD_DATA_PRODIS
}
